import { OverlayRef } from '@angular/cdk/overlay';

import { RtOverlayConfig } from './overlay-state';

export interface RtOverlayRef extends OverlayRef {
  attachResult: ReturnType<OverlayRef['attach']>;

  getConfig: () => RtOverlayConfig;
  getOverlayLevel: () => number;
}

const OverlayRefPrototype = <any>OverlayRef.prototype;
OverlayRefPrototype.getOverlayLevel = function (this: RtOverlayRef) {
  return this.getConfig().level;
};

const attach = OverlayRefPrototype.attach;
OverlayRefPrototype.attach = function (this: RtOverlayRef) {
  const config = this.getConfig();
  this.attachResult = attach.apply(this, arguments);
  if (config?.disablePointerEvents) {
    this['_togglePointerEvents'](!config?.disablePointerEvents);
  }
  return this.attachResult;
};

export { OverlayRef } from '@angular/cdk/overlay';
